var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseBlack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "#121212"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#383838"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8242 18.9752C19.8799 19.031 19.9241 19.0971 19.9543 19.17C19.9845 19.2428 20 19.3209 20 19.3997C20 19.4785 19.9845 19.5566 19.9543 19.6294C19.9241 19.7023 19.8799 19.7684 19.8242 19.8242C19.7684 19.8799 19.7023 19.9241 19.6294 19.9543C19.5566 19.9845 19.4785 20 19.3997 20C19.3209 20 19.2428 19.9845 19.17 19.9543C19.0971 19.9241 19.031 19.8799 18.9752 19.8242L14 14.8482L9.02478 19.8242C8.9122 19.9368 8.75951 20 8.6003 20C8.44109 20 8.2884 19.9368 8.17582 19.8242C8.06325 19.7116 8 19.5589 8 19.3997C8 19.2405 8.06325 19.0878 8.17582 18.9752L13.1518 14L8.17582 9.02478C8.06325 8.9122 8 8.75951 8 8.6003C8 8.44109 8.06325 8.2884 8.17582 8.17582C8.2884 8.06325 8.44109 8 8.6003 8C8.75951 8 8.9122 8.06325 9.02478 8.17582L14 13.1518L18.9752 8.17582C19.0878 8.06325 19.2405 8 19.3997 8C19.5589 8 19.7116 8.06325 19.8242 8.17582C19.9368 8.2884 20 8.44109 20 8.6003C20 8.75951 19.9368 8.9122 19.8242 9.02478L14.8482 14L19.8242 18.9752Z",
    fill: "#D3D7D9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close_black.d580c3aedb26713c6abb185d2345636e.svg";